// extracted by mini-css-extract-plugin
module.exports = {"section":"F_CA_section__5aBLo"};